import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import useInterval from '../../../hooks/useInterval';
import type { Notification } from '../NotificationManager';
import { addListener } from '../NotificationManager';
import { StyledToasts, Wrapper } from './NotificationContainer.styled';

const DEFAULT_INTERVAL_DELAY = 500;
const DEFAULT_TOP_UNITS_POSITION = 12;

interface NotificationContainerProps {
  topPosition?: string;
  intervalDelay?: number;
}

const NotificationContainer = ({
  topPosition,
  intervalDelay = DEFAULT_INTERVAL_DELAY,
}: NotificationContainerProps) => {
  const [toasts, setToasts] = useState<Notification[]>([]);
  const theme = useTheme();

  const positionTop = topPosition || theme.size.units(DEFAULT_TOP_UNITS_POSITION);

  useEffect(() => {
    return addListener((toast: Notification) => {
      setToasts(prevToasts => [...prevToasts, toast]);
    });
  }, []);

  const isExpired = ({ expiredOn }: Notification) => {
    if (expiredOn === 0) {
      return false;
    }

    return expiredOn < Date.now();
  };

  useInterval(
    () => {
      setToasts(
        toasts.map(toast => (isExpired(toast) ? { ...toast, removed: true } : toast)),
      );
    },
    toasts.length > 0 ? intervalDelay : null,
  );

  const handleRemoveToast = (id: string) => {
    setToasts(toasts => toasts.filter(toast => toast.id !== id));
  };

  return (
    <Wrapper $topPosition={positionTop}>
      <StyledToasts toasts={toasts} onRemove={handleRemoveToast} />
    </Wrapper>
  );
};

export default NotificationContainer;
